import { GroupPricingForm } from '@/features/group-pricing/components';
import { GroupPricingProvider } from '@/features/group-pricing/context/group-pricing-context';

export const GroupDisplacementCalculator = () => {
	return (
		<GroupPricingProvider>
			{/* // TODO get the Form context here, or put the tables in the form */}
			<div className='tw-w-full tw-max-w-7xl tw-mx-auto tw-p-4'>
				<GroupPricingForm />
			</div>
		</GroupPricingProvider>
	);
};
